import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { DEVICE, LIBRARY_ASSETS_ORIGIN_URL } from '@/constants';
import {
  nativeFunction,
  callNativeFunction,
  nativeFunctionParamsConstant,
  OS,
} from '@/utils/detectDevice';
import { scorm, statistic } from '@/api';
import DeviceTesting from '@/components/DeviceTesting';
import { quitBook, convertObject } from '@/utils/tools';
import RequestErrors from '@/components/RequestErrors';
import './style.less';

const audioRef = React.createRef();

const BookCover = ({ history, match }) => {
  const os = OS.TYPE;
  const { params } = match;
  const [deviceTestingShow, setDeviceTestingShow] = useState(false);
  const [src, setSrc] = useState('');
  const [cover, setCover] = useState('');
  const [bookData, setBookData] = useState('');
  const [requestCode, setRequestCode] = useState('');

  const getScorm = async () => {
    const stageId = params.stageId.split('-')[0];
    const reqParams = { ...params, stageId };
    const result = await scorm.list(reqParams);
    const { code, data } = convertObject(result);
    setRequestCode(code);
    if (code === 200) {
      setBookData(data[0]);
      const { title_id: titleId } = data[0].page[0];
      setSrc(`${OS.URL_HOST()}Library/${titleId}/${titleId}_Audio.ogg`);
      setCover(`${LIBRARY_ASSETS_ORIGIN_URL}Library/${titleId}/${titleId}_Image.png`);
    }
  };

  useEffect(() => {
    getScorm();
    return () => {
      (os === DEVICE.PC)
        ? audioRef.current.pause()
        : callNativeFunction(nativeFunction.STOP_LOCAL_ALL)();
    };
  }, []);

  useEffect(() => {
    src && ((os === DEVICE.PC)
      ? audioRef.current.play()
      : callNativeFunction(nativeFunction.PLAY_LOCAL_AUDIO)({
        url: src,
        speed: 1,
        type: nativeFunctionParamsConstant.AUDIO,
      }));
  }, [src]);

  const handleClose = () => {
    quitBook({ params, push: history.push });
  };

  const handleShare = () => history.push(`/share/${params.id}/${params.attempt}/${params.stage}/${params.stageId}`);
  const handleReading = () => {
    history.push(`/reading/${params.id}/${params.attempt}/${params.stage}/${params.stageId}`);
    statistic.post({ read_book_num: 1 });
  };

  return (
    <div className="cover-bg">
      {requestCode === 408 ? <RequestErrors callback={handleClose} /> : null}
      <div className="cover-container">
        <div className="cover-header">
          {requestCode === 200 && <div className="close-btn" onClick={handleClose} />}
          <div className="share-btn" onClick={handleShare} />
          {os === DEVICE.PC && <div className="device-test-btn" onClick={() => setDeviceTestingShow(true)} />}
        </div>
        <div className="cover-content">
          {cover && <img src={cover} alt="" />}
          <div className="book-title">{bookData && bookData.fullname}</div>
        </div>
        <div className="book-pedestal" />
        {bookData && bookData.first_page_desc ? <div className="book-introduce" dangerouslySetInnerHTML={{ __html: bookData.first_page_desc }} /> : null}
        <div className="start" onClick={handleReading}>start</div>
      </div>
      <audio src={src} ref={audioRef} />
      {deviceTestingShow ? <DeviceTesting cloneName="" hide={() => setDeviceTestingShow(false)} /> : null}
    </div>
  );
};

BookCover.propTypes = {
  history: PropTypes.object.isRequired,
  match: PropTypes.object,
};

export default withRouter(BookCover);
